import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";

const API_URL = environment.apiUrl;

const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable()
export class CertificateService {

    constructor(private http: HttpClient){
    }

    public sendCertificate(type, equiNumber, eMail, language): Observable<boolean> {
        let url = `${API_URL}/equi-details/send-certificate?type=${encodeURIComponent(type)}&equipmentNumber=${encodeURIComponent(equiNumber)}&eMail=${encodeURIComponent(eMail)}&language=${encodeURIComponent(language)}`;
        console.log('SystemDetailService: ' + url);

        return this.http.get<boolean>(url);
    }
}
